import { Typography } from '@mui/material'
import type { FC, HTMLAttributeAnchorTarget, PropsWithChildren } from 'react'
import type { To } from 'react-router-dom'

import { UnstyledLink } from '@hcr/pwa/components'

interface FormLinkProps extends PropsWithChildren {
  rel?: string
  target?: HTMLAttributeAnchorTarget
  to: To
}

export const FormLink: FC<FormLinkProps> = ({ children, rel, target, to }) => {
  return (
    <UnstyledLink to={to} target={target} rel={rel}>
      <Typography variant='textLinkM'>{children}</Typography>
    </UnstyledLink>
  )
}
